import React, { FunctionComponent } from 'react'

import { SubjectFeatureCollection } from '../../../common/subjectTypes'
import { PageLayout } from '../PageLayout/PageLayout'
import { SubjectSearchResultMap } from '../SubjectSearchResultMap/SubjectSearchResultMap'
import { SubjectSearchResultTable } from '../SubjectSearchResultTable/SubjectSearchResultTable'

export interface SubjectSearchResultProps {
  data: SubjectFeatureCollection
}

export const SubjectSearchResult: FunctionComponent<SubjectSearchResultProps> =
  props => {
    return (
      <PageLayout isNew isNewTitle="Detail subjektu" className="flex space-x-6">
        <div className="w-full lg:w-1/2">
          <SubjectSearchResultTable data={props.data.features} />
        </div>
        <div className="hidden lg:block w-1/2">
          <SubjectSearchResultMap dataSource={props.data} />
        </div>
      </PageLayout>
    )
  }
